"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LarixHDWallet = exports.LarixWebWallet = exports.LarixWallet = void 0;
const web3_js_1 = require("@solana/web3.js");
class LarixWallet {
    constructor(connection, sendOption, confirm, commitment, logger) {
        this.connection = connection;
        this.sendOption = sendOption;
        this.confirm = confirm;
        this.commitment = commitment;
        this.logger = logger;
    }
}
exports.LarixWallet = LarixWallet;
class LarixWebWallet extends LarixWallet {
    constructor(connection, wallet, sendOption = { skipPreflight: true }, confirm = true, commitment = "confirmed", logger) {
        super(connection, sendOption, confirm, commitment, logger);
        this.wallet = wallet;
    }
    get publicKey() {
        return this.wallet.publicKey;
    }
    sendTransaction(instructions, signers) {
        return __awaiter(this, void 0, void 0, function* () {
            let transaction = new web3_js_1.Transaction();
            transaction.feePayer = this.wallet.publicKey;
            instructions.forEach((instruction) => transaction.add(instruction));
            transaction.recentBlockhash = (yield this.connection.getRecentBlockhash("max")).blockhash;
            if (signers.length > 0) {
                transaction.partialSign(...signers);
            }
            transaction = yield this.wallet.signTransaction(transaction);
            const rawTransaction = transaction.serialize();
            const txid = yield this.connection.sendRawTransaction(rawTransaction, this.sendOption);
            if (this.logger) {
                this.logger(txid);
            }
            if (this.confirm) {
                const status = yield this.connection.confirmTransaction(txid, this.commitment);
                return {
                    id: txid,
                    result: status
                };
            }
            else {
                return {
                    id: txid
                };
            }
        });
    }
}
exports.LarixWebWallet = LarixWebWallet;
class LarixHDWallet extends LarixWallet {
    constructor(connection, signer, sendOption, confirm = false, commitment = "confirmed", logger) {
        super(connection, sendOption, confirm, commitment, logger);
        this.signer = signer;
    }
    get publicKey() {
        return this.signer.publicKey;
    }
    sendTransaction(instructions, signers) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = new web3_js_1.Transaction();
            transaction.instructions = instructions;
            const txid = yield this.connection.sendTransaction(transaction, [this.signer, ...signers], this.sendOption);
            if (this.logger) {
                this.logger(txid);
            }
            if (this.confirm) {
                const status = yield this.connection.confirmTransaction(txid, this.commitment);
                return {
                    id: txid,
                    result: status
                };
            }
            else {
                return {
                    id: txid
                };
            }
        });
    }
}
exports.LarixHDWallet = LarixHDWallet;
